import { from, of, timer } from "rxjs";
import { switchMap } from "rxjs/operators";
import { setOfferFilter } from "../../../constants/setOfferFilter";
import { selectIsFortuneTellerEventPackage, selectIsFortuneTellerEventRunning, } from "../../../selectors/selectFortuneTellerEventInfo";
import { utilGrantRewards } from "../../../utils/utilGrantRewards";
import { utilPackage } from "../../../utils/utilPackage";
import { utilTime } from "../../../utils/utilTime";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { actionDoghouseFinishTreatCooldown } from "../../doghouse/actionDoghouse";
import { actionFortuneTellerEventFinishBuyPackageCoolDown } from "../../fortune-teller-event/actionFortuneTellerEventInfo";
import { actionGrantRewardsReceived } from "../../grant-rewards/actionGrantRewards";
import { TypeGrantRewards } from "../../grant-rewards/TypeGrantRewards";
import { actionInventoryInfoAddBuilding, actionInventoryInfoAddProfilePicture, actionInventoryInfoAddResource, } from "../../info/inventory/actionInventoryInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionShopRequestShiftLevelUpdate } from "../../shop/actionShop";
export var networkNoticeGrantRewardHandler = function (action$, state$, deps) { return function (res) {
    var state = state$.value;
    var packageId = res.packageId, paymentOfferId = res.paymentOfferId, resourceRewards = res.resourceRewards, buildingRewards = res.buildingRewards, profilePictureRewards = res.profilePictureRewards;
    var isPackageChest = state.storeInfo.package &&
        utilPackage.isPackageChest(state.storeInfo.package.balancing, packageId);
    var isFortuneTellerReward = selectIsFortuneTellerEventRunning(state) &&
        selectIsFortuneTellerEventPackage(state, packageId);
    var isPackageDogTreat = utilPackage.isPackageDogTreat(packageId);
    var isPackageShopReward = utilGrantRewards.isPackageShopReward(res);
    var isRewardResources = utilGrantRewards.isRewardResources(res);
    var isRewardBuildings = utilGrantRewards.isRewardBuildings(res);
    var isRewardProfilePictures = utilGrantRewards.isRewardProfilePictures(res);
    // RewardType == Dog treat
    if (isPackageDogTreat) {
        var lastTreatCooldownTimestamp = state$.value.doghouse.cooldownTime;
        var secondsRemainingForCooldown = utilTime.secondsLeftTill(lastTreatCooldownTimestamp);
        var millisecondsRemainingForCooldown = utilTime.secondsToMs(secondsRemainingForCooldown);
        return timer(lastTreatCooldownTimestamp ? millisecondsRemainingForCooldown : 0).pipe(switchMap(function () {
            return from([
                actionDoghouseFinishTreatCooldown(),
                actionGrantRewardsReceived(TypeGrantRewards.Doghouse, res),
                actionModalOpen(IdModal.DogTreatReward),
            ]);
        }));
    }
    // RewardType == Shop
    if (isPackageShopReward) {
        if (!setOfferFilter.has(paymentOfferId)) {
            return from([
                actionGrantRewardsReceived(TypeGrantRewards.Shop, res),
                actionShopRequestShiftLevelUpdate(),
            ]);
        }
        else {
            return of(actionShopRequestShiftLevelUpdate());
        }
    }
    var actions = [];
    // Handle resource rewards
    if (isRewardResources) {
        var rewards = utilGrantRewards.getResourcesRewards(res);
        var uniqueAnimationId = utilGrantRewards.getUniqueAnimationId(res);
        // Open reward dialog if package is chest
        if (isPackageChest) {
            return from([
                actionGrantRewardsReceived(TypeGrantRewards.Chest, res),
                actionModalOpen(IdModal.CollectRewardsStore),
            ]);
        }
        else if (isFortuneTellerReward) {
            var coolDownTimeStamp = state$.value.fortuneTellerEventInfo.cooldownTime;
            var coolDownRemainingSeconds = utilTime.secondsLeftTill(coolDownTimeStamp);
            var millisecondsRemainingForCooldown = utilTime.secondsToMs(coolDownRemainingSeconds);
            return timer(coolDownTimeStamp ? millisecondsRemainingForCooldown : 0).pipe(switchMap(function () {
                return from([
                    actionGrantRewardsReceived(TypeGrantRewards.FortuneTeller, res),
                    actionModalOpen(IdModal.CollectReward),
                    actionFortuneTellerEventFinishBuyPackageCoolDown(),
                ]);
            }));
        }
        else {
            actions.push(actionInventoryInfoAddResource(resourceRewards), actionAddPelletsInScreenCenterAnimation(uniqueAnimationId, rewards));
        }
    }
    // Handle building rewards
    if (isRewardBuildings) {
        actions.push(actionInventoryInfoAddBuilding(buildingRewards));
    }
    // Handle profile picture rewards
    if (isRewardProfilePictures) {
        // Open reward dialog if package is chest
        if (isPackageChest) {
            return from([
                actionGrantRewardsReceived(TypeGrantRewards.Chest, res),
                actionModalOpen(IdModal.CollectRewardsStore),
            ]);
        }
        else {
            actions.push(actionInventoryInfoAddProfilePicture(profilePictureRewards));
        }
    }
    return actions;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeGrantRewardHandler.ts
// module id = 2011
// module chunks = 3